import React, { useState, useEffect } from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import {
  RadioButton,
  RadioButtonChangeEvent,
} from "@progress/kendo-react-inputs";
import { useSelector } from "react-redux";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import { useAppDispatch } from "../Core/store.hooks";
import { Checkbox } from "@progress/kendo-react-inputs";
import { JSONParser } from "@amcharts/amcharts4/core";
import AlarmFilter from "../Alarms/AlarmFilter";
import DataTypesFilter from "../Common/Components/DataTypesFilter";
import ChartOptions from "../Common/Components/ChartOptions";
import TriggerFilter from "../Triggers/TriggerFilter";
import MachineTimesFilter from "../MachineTimes/Filter";
import EventTypes from "../Events/EventFilter";
import {
    getSettingsSelector, updateSelectedHomepage
} from "./Slice";
import Spinner from "../Common/Components/spinner";

type handler = () => void;
interface settingsProps {
  visible: boolean;
  toggleVisible: handler;
}
const Settings = (props: settingsProps) => {
    const settings = useSelector(getSettingsSelector);
  const [showSuccess, updateShowSuccess] = useState(false);
    const [selectedHomepage, updateSelectedHomepage] = useState("events");
    useEffect(() => {
        
        if (settings!= undefined) {
            updateSelectedHomepage(settings.homepage)
        }
        
    }, [settings]);
  const dispatch = useAppDispatch();

  const saveSettings = () => {
 
    props.toggleVisible();

    updateShowSuccess(true);
  };
  useEffect(() => {
    updateShowSuccess(false);
  }, [props.visible]);


  const handleChange = React.useCallback(
    (e: RadioButtonChangeEvent) => {
          updateSelectedHomepage(e.value);
        //  dispatch(updateSelectedHomepage(e.value));
          const obj = { homepage: e.value };
          const myObjectString = JSON.stringify(obj);
          localStorage.setItem("settings", myObjectString);
    },
      [updateSelectedHomepage]
  );
    const renderContent = () => {
        return null;
        return(
            <div>
                <h5>Select Homepage</h5>
            <RadioButton
                name="group1"
                value="events"
                checked={selectedHomepage === "events"}
                label="Events"
                onChange={handleChange}
            />
            <br />
            <RadioButton
                name="group1"
                value="alarms"
                checked={selectedHomepage === "alarms"}
                label="Alarms"
                onChange={handleChange}
            />
            <br />
            <RadioButton
                name="group1"
                value="triggers"
                checked={selectedHomepage === "triggers"}
                label="Triggers"
                onChange={handleChange}
                />
                <br />
                <RadioButton
                    name="group1"
                    value="timeline"
                    checked={selectedHomepage === "timeline"}
                    label="Timeline"
                    onChange={handleChange}
                />
                <br />
                <RadioButton
                    name="group1"
                    value="machineTimes"
                    checked={selectedHomepage === "machineTimes"}
                    label="Machine Times"
                    onChange={handleChange}
                />
                <br />
                <RadioButton
                    name="group1"
                    value="rootCause"
                    checked={selectedHomepage === "rootCause"}
                    label="Root Cause"
                    onChange={handleChange}
                />
                <br />
                <RadioButton
                    name="group1"
                    value="timeSeries"
                    checked={selectedHomepage === "timeSeries"}
                    label="Time Series Chart"
                    onChange={handleChange}
                />
                <br />
                <RadioButton
                    name="group1"
                    value="startUp"
                    checked={selectedHomepage === "startUp"}
                    label="Start Up"
                    onChange={handleChange}
                />
                <hr/>
            </div>
        )
    }
  const renderDialog = () => {
    if (props.visible) {
      
      return (
        <Dialog title={"Settings"} onClose={props.toggleVisible} width={600}>
          <div
            style={{
              backgroundColor: "#fff",
              padding: "20px",
              height: "300px",
              overflowY: "scroll",
            }}
           >
                  {renderContent() }
           </div>

          <DialogActionsBar>
            <button
              className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
              onClick={saveSettings}
            >
              Save And Exit
            </button>

            <button
              className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
              onClick={props.toggleVisible}
            >
              Close
            </button>
          </DialogActionsBar>
        </Dialog>
      );
    }
    return null;
  };
  return renderDialog();
};

export default Settings;
